import React from 'react';

const Label = ({ text, htmlFor, className }) => {
    return (
        <label 
            htmlFor={htmlFor} 
            className={`w-[170px] text-black font-bold text-[14px] leading-[40px] pl-0 pr-3 box-border float-left text-left font-yahei ${className}`}
            style={{fontFamily:'Microsoft YaHei'}}
        >
            {text}
        </label>
    );
};

export default Label;